export const NAME = 'dossier';